import React from 'react'
import ReactDOM from 'react-dom'
import App from './containers/BriefSocial'

ReactDOM.render(<App />, document.getElementById('app'))
